export default __webpack_public_path__ + "static/media/815.7428cfd2.gif";